import VSelect from './VSelect'

export default {
  VSelect
}



// WEBPACK FOOTER //
// ./src/components/selects/index.js